import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function HomePage() {
  const [showNewsletter, setShowNewsletter] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-black/40 backdrop-blur-md border-b border-cyan-400/30">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/13311d918650e6bdc287990a476eb090/a902c8c3bd81fc0c31ca3a4e0028fe02.jpeg" 
                alt="A'DAUDET SHOP Logo" 
                className="w-12 h-12 rounded-full object-cover border-2 border-cyan-400 shadow-[0_0_15px_rgba(0,255,240,0.6)]"
              />
              <h1 className="text-2xl font-bold text-cyan-400 tracking-wider" style={{ textShadow: '0 0 20px rgba(0,255,240,0.8)' }}>
                A'DAUDET SHOP
              </h1>
            </div>
            
            <div className="flex items-center gap-8">
              <button 
                onClick={() => scrollToSection('boissons')}
                className="text-white hover:text-cyan-400 transition-all duration-300 font-medium relative group whitespace-nowrap"
              >
                Boissons
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-cyan-400 group-hover:w-full transition-all duration-300 shadow-[0_0_10px_rgba(0,255,240,0.8)]"></span>
              </button>
              <button 
                onClick={() => scrollToSection('confiseries')}
                className="text-white hover:text-cyan-400 transition-all duration-300 font-medium relative group whitespace-nowrap"
              >
                Confiseries
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-cyan-400 group-hover:w-full transition-all duration-300 shadow-[0_0_10px_rgba(0,255,240,0.8)]"></span>
              </button>
              <button 
                onClick={() => scrollToSection('alcools')}
                className="text-white hover:text-cyan-400 transition-all duration-300 font-medium relative group whitespace-nowrap"
              >
                Alcools
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-cyan-400 group-hover:w-full transition-all duration-300 shadow-[0_0_10px_rgba(0,255,240,0.8)]"></span>
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-white hover:text-cyan-400 transition-all duration-300 font-medium relative group whitespace-nowrap"
              >
                Contact
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-cyan-400 group-hover:w-full transition-all duration-300 shadow-[0_0_10px_rgba(0,255,240,0.8)]"></span>
              </button>
            </div>

            <div className="flex items-center gap-4">
              <a 
                href="https://www.tiktok.com/@mocroshit6.0?_r=1&_t=ZN-92z1A036EK" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-black transition-all duration-300 shadow-[0_0_15px_rgba(0,255,240,0.6)] hover:shadow-[0_0_25px_rgba(0,255,240,0.9)] cursor-pointer"
              >
                <i className="ri-tiktok-fill text-xl"></i>
              </a>
              <div className="px-4 py-2 bg-cyan-400/20 border border-cyan-400 rounded-full text-cyan-400 font-bold text-sm whitespace-nowrap" style={{ textShadow: '0 0 10px rgba(0,255,240,0.8)' }}>
                20H - 6H
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
        {/* Background with gradient and grid */}
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-pink-600 to-cyan-500">
          <div className="absolute inset-0 opacity-30" style={{
            backgroundImage: `linear-gradient(0deg, transparent 24%, rgba(0, 255, 240, 0.3) 25%, rgba(0, 255, 240, 0.3) 26%, transparent 27%, transparent 74%, rgba(0, 255, 240, 0.3) 75%, rgba(0, 255, 240, 0.3) 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%, rgba(0, 255, 240, 0.3) 25%, rgba(0, 255, 240, 0.3) 26%, transparent 27%, transparent 74%, rgba(0, 255, 240, 0.3) 75%, rgba(0, 255, 240, 0.3) 76%, transparent 77%, transparent)`,
            backgroundSize: '50px 50px'
          }}></div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/50"></div>
        </div>

        {/* Palm trees silhouette */}
        <div className="absolute bottom-0 left-0 w-64 h-64 opacity-40">
          <svg viewBox="0 0 200 200" className="w-full h-full">
            <path d="M100 180 L100 100 M100 100 Q80 90 60 85 M100 100 Q90 85 85 70 M100 100 Q110 85 115 70 M100 100 Q120 90 140 85" 
              stroke="currentColor" 
              strokeWidth="3" 
              fill="none" 
              className="text-cyan-400"
              style={{ filter: 'drop-shadow(0 0 10px rgba(0,255,240,0.8))' }}
            />
          </svg>
        </div>

        {/* Content */}
        <div className="relative z-10 text-center px-6 max-w-5xl">
          <div className="mb-8">
            <h2 className="text-7xl md:text-8xl font-black mb-4 tracking-wider" style={{ 
              fontFamily: "'Orbitron', sans-serif",
              textShadow: '0 0 30px rgba(0,255,240,0.9), 0 0 60px rgba(0,255,240,0.6)',
              color: '#00FFF0'
            }}>
              NIGHT SHOP
            </h2>
            <h3 className="text-5xl md:text-6xl font-black mb-4 tracking-wider" style={{ 
              fontFamily: "'Orbitron', sans-serif",
              textShadow: '0 0 30px rgba(255,0,110,0.9), 0 0 60px rgba(255,0,110,0.6)',
              color: '#FF006E'
            }}>
              OUVERT TOUTE LA NUIT
            </h3>
            <h4 className="text-4xl md:text-5xl font-black tracking-wider" style={{ 
              fontFamily: "'Orbitron', sans-serif",
              textShadow: '0 0 30px rgba(139,0,255,0.9), 0 0 60px rgba(139,0,255,0.6)',
              color: '#8B00FF'
            }}>
              CREIL 24/7
            </h4>
          </div>
          
          <p className="text-xl md:text-2xl text-white mb-12 font-light tracking-wide" style={{ 
            fontFamily: "'Orbitron', sans-serif",
            textShadow: '0 0 15px rgba(255,255,255,0.5)'
          }}>
            Votre épicerie nocturne style Vice City
          </p>

          <button 
            onClick={() => scrollToSection('produits')}
            className="group relative inline-flex items-center gap-4 px-12 py-5 bg-cyan-400 text-black text-xl font-bold rounded-full hover:bg-cyan-300 transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ 
              boxShadow: '0 0 30px rgba(0,255,240,0.8), 0 0 60px rgba(0,255,240,0.4)',
              fontFamily: "'Orbitron', sans-serif"
            }}
          >
            VOIR LE MENU
            <span className="w-10 h-10 flex items-center justify-center rounded-full bg-pink-600 text-white group-hover:scale-110 transition-transform duration-300" style={{ boxShadow: '0 0 20px rgba(255,0,110,0.8)' }}>
              <i className="ri-arrow-right-line text-xl"></i>
            </span>
          </button>
        </div>
      </section>

      {/* Products Section */}
      <section id="produits" className="py-20 px-6 bg-gradient-to-b from-black via-purple-950/20 to-black">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-6xl font-black mb-16 bg-gradient-to-r from-cyan-400 to-pink-600 bg-clip-text text-transparent flex items-center gap-4" style={{ 
            fontFamily: "'Orbitron', sans-serif",
            textShadow: '0 4px 20px rgba(0,255,240,0.3)'
          }}>
            🌴 NOS PRODUITS
          </h2>

          {/* Boissons Section */}
          <div id="boissons" className="mb-20">
            <h3 className="text-4xl font-bold text-cyan-400 mb-8 flex items-center gap-3" style={{ 
              fontFamily: "'Orbitron', sans-serif",
              textShadow: '0 0 20px rgba(0,255,240,0.8)'
            }}>
              <i className="ri-goblet-fill"></i>
              BOISSONS
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { name: 'Coca-Cola', price: '1€', image: 'https://public.readdy.ai/ai/img_res/d36f694b16aa390306dc59658d1088ce.jpg' },
                { name: 'Coca-Cola Zero', price: '1€', image: 'https://readdy.ai/api/search-image?query=Coca-Cola%20Zero%20black%20bottle%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=coca-zero-new&orientation=portrait' },
                { name: 'Fanta Orange', price: '1€', image: 'https://readdy.ai/api/search-image?query=Fanta%20Orange%20bottle%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=fanta-orange-new&orientation=portrait' },
                { name: 'Sprite', price: '1€', image: 'https://readdy.ai/api/search-image?query=Sprite%20lemon%20lime%20soda%20bottle%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=sprite-new&orientation=portrait' },
                { name: 'Oasis Tropical', price: '1€', image: 'https://readdy.ai/api/search-image?query=Oasis%20Tropical%20fruit%20juice%20bottle%20with%20orange%20yellow%20label%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=oasis-tropical-real&orientation=portrait' },
                { name: 'Oasis Pomme Cassis Framboise', price: '1€', image: 'https://readdy.ai/api/search-image?query=Oasis%20apple%20blackcurrant%20raspberry%20juice%20bottle%20with%20purple%20red%20label%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=oasis-pomme-cassis&orientation=portrait' },
                { name: 'Oasis Orange', price: '1€', image: 'https://readdy.ai/api/search-image?query=Oasis%20Orange%20juice%20bottle%20with%20bright%20orange%20label%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=oasis-orange-real&orientation=portrait' },
                { name: 'Oasis Mangue Goyave', price: '1€', image: 'https://readdy.ai/api/search-image?query=Oasis%20mango%20guava%20juice%20bottle%20with%20yellow%20orange%20label%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=oasis-mangue-goyave&orientation=portrait' },
                { name: 'Oasis Pêche Abricot', price: '1€', image: 'https://readdy.ai/api/search-image?query=Oasis%20peach%20apricot%20juice%20bottle%20with%20peach%20colored%20label%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=oasis-peche-abricot&orientation=portrait' },
                { name: 'Orangina', price: '1€', image: 'https://readdy.ai/api/search-image?query=Orangina%20iconic%20bulb%20shaped%20bottle%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=orangina-real&orientation=portrait' },
                { name: 'Tropico', price: '1€', image: 'https://readdy.ai/api/search-image?query=Tropico%20exotic%20fruit%20juice%20bottle%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=tropico-real&orientation=portrait' },
                { name: 'Ice Tea Pêche', price: '1€', image: 'https://readdy.ai/api/search-image?query=Lipton%20Ice%20Tea%20Peach%20bottle%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=icetea-peche&orientation=portrait' },
                { name: 'Red Bull Original', price: '2€', badge: 'ENERGY', image: 'https://readdy.ai/api/search-image?query=Red%20Bull%20Original%20energy%20drink%20silver%20blue%20can%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=redbull-original-real&orientation=portrait' },
                { name: 'Red Bull Sugarfree', price: '2€', badge: 'ENERGY', image: 'https://readdy.ai/api/search-image?query=Red%20Bull%20Sugarfree%20energy%20drink%20silver%20grey%20can%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=redbull-sugarfree&orientation=portrait' },
                { name: 'Red Bull Tropical', price: '2€', badge: 'ENERGY', image: 'https://readdy.ai/api/search-image?query=Red%20Bull%20Tropical%20Yellow%20Edition%20energy%20drink%20yellow%20can%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=redbull-tropical-real&orientation=portrait' },
                { name: 'Red Bull Pastèque', price: '2€', badge: 'ENERGY', image: 'https://readdy.ai/api/search-image?query=Red%20Bull%20Watermelon%20Summer%20Edition%20energy%20drink%20pink%20red%20can%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=redbull-pasteque&orientation=portrait' },
                { name: 'Red Bull Coconut Berry', price: '2€', badge: 'ENERGY', image: 'https://readdy.ai/api/search-image?query=Red%20Bull%20Coconut%20Berry%20White%20Edition%20energy%20drink%20white%20can%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=redbull-coconut&orientation=portrait' },
                { name: 'Red Bull Fruits Rouges', price: '2€', badge: 'ENERGY', image: 'https://readdy.ai/api/search-image?query=Red%20Bull%20Red%20Edition%20energy%20drink%20red%20cranberry%20can%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=redbull-rouge&orientation=portrait' },
                { name: 'Red Bull Myrtille', price: '2€', badge: 'ENERGY', image: 'https://readdy.ai/api/search-image?query=Red%20Bull%20Blueberry%20Blue%20Edition%20energy%20drink%20blue%20can%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=redbull-myrtille&orientation=portrait' },
                { name: 'Red Bull Pêche', price: '2€', badge: 'ENERGY', image: 'https://readdy.ai/api/search-image?query=Red%20Bull%20Peach%20Edition%20energy%20drink%20peach%20colored%20can%20on%20simple%20dark%20gradient%20background%20with%20neon%20cyan%20and%20pink%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting%2C%20realistic%20product%20shot&width=400&height=500&seq=redbull-peche&orientation=portrait' }
              ].map((product, index) => (
                <div 
                  key={index}
                  className="group relative bg-black/60 backdrop-blur-sm rounded-3xl border-2 border-cyan-400/50 overflow-hidden hover:border-cyan-400 hover:scale-105 transition-all duration-300 cursor-pointer"
                  style={{ boxShadow: '0 0 20px rgba(0,255,240,0.3)' }}
                >
                  {product.badge && (
                    <div className="absolute top-4 left-4 z-10 px-3 py-1 bg-pink-600/80 backdrop-blur-sm rounded-full text-white text-xs font-bold" style={{ textShadow: '0 0 10px rgba(255,0,110,0.8)' }}>
                      {product.badge}
                    </div>
                  )}
                  <div className="w-full h-64 bg-gradient-to-b from-cyan-900/30 to-black overflow-hidden">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="w-full h-full object-contain object-top p-4 group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <h4 className="text-lg font-bold text-white mb-2">{product.name}</h4>
                    <p className="text-4xl font-black text-cyan-400 mb-2" style={{ 
                      fontFamily: "'Orbitron', sans-serif",
                      textShadow: '0 0 15px rgba(0,255,240,0.8)'
                    }}>
                      {product.price}
                    </p>
                    <p className="text-xs text-gray-400 italic">En magasin uniquement</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Confiseries Section */}
          <div id="confiseries" className="mb-20">
            <h3 className="text-4xl font-bold text-purple-400 mb-8 flex items-center gap-3" style={{ 
              fontFamily: "'Orbitron', sans-serif",
              textShadow: '0 0 20px rgba(139,0,255,0.8)'
            }}>
              <i className="ri-cake-3-fill"></i>
              CONFISERIES
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-6">
              {[
                { name: 'Mars', price: '1€', image: 'https://readdy.ai/api/search-image?query=Mars%20chocolate%20bar%20on%20simple%20dark%20gradient%20background%20with%20neon%20purple%20and%20cyan%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting&width=300&height=300&seq=mars1&orientation=squarish' },
                { name: 'Twix', price: '1€', image: 'https://readdy.ai/api/search-image?query=Twix%20chocolate%20bar%20on%20simple%20dark%20gradient%20background%20with%20neon%20purple%20and%20cyan%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting&width=300&height=300&seq=twix1&orientation=squarish' },
                { name: 'Snickers', price: '1€', image: 'https://readdy.ai/api/search-image?query=Snickers%20chocolate%20bar%20on%20simple%20dark%20gradient%20background%20with%20neon%20purple%20and%20cyan%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting&width=300&height=300&seq=snickers1&orientation=squarish' },
                { name: 'Kinder Bueno', price: '1€', image: 'https://readdy.ai/api/search-image?query=Kinder%20Bueno%20chocolate%20bar%20on%20simple%20dark%20gradient%20background%20with%20neon%20purple%20and%20cyan%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting&width=300&height=300&seq=kinder1&orientation=squarish' }
              ].map((product, index) => (
                <div 
                  key={index}
                  className="group relative bg-black/60 backdrop-blur-sm rounded-3xl border-2 border-purple-400/50 overflow-hidden hover:border-purple-400 hover:scale-105 transition-all duration-300 cursor-pointer"
                  style={{ boxShadow: '0 0 20px rgba(139,0,255,0.3)' }}
                >
                  <div className="absolute top-3 left-3 z-10 px-2 py-1 bg-purple-600/80 backdrop-blur-sm rounded-full text-white text-xs font-bold" style={{ textShadow: '0 0 10px rgba(139,0,255,0.8)' }}>
                    SWEET
                  </div>
                  <div className="w-full h-48 bg-gradient-to-b from-purple-900/30 to-black overflow-hidden">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="w-full h-full object-contain object-top p-4 group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-4">
                    <h4 className="text-base font-bold text-white mb-1">{product.name}</h4>
                    <p className="text-3xl font-black text-purple-400" style={{ 
                      fontFamily: "'Orbitron', sans-serif",
                      textShadow: '0 0 15px rgba(139,0,255,0.8)'
                    }}>
                      {product.price}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Alcools Section */}
          <div id="alcools" className="mb-20">
            <h3 className="text-4xl font-bold text-pink-400 mb-8 flex items-center gap-3" style={{ 
              fontFamily: "'Orbitron', sans-serif",
              textShadow: '0 0 20px rgba(255,0,110,0.8)'
            }}>
              <i className="ri-wine-glass-fill"></i>
              ALCOOLS PREMIUM
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { name: 'Absolut Vodka', price: '40€', image: 'https://readdy.ai/api/search-image?query=Absolut%20vodka%20bottle%20on%20simple%20dark%20gradient%20background%20with%20neon%20pink%20and%20cyan%20lighting%20effects%2C%20premium%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting&width=400&height=600&seq=absolut1&orientation=portrait' },
                { name: 'Cîroc Vodka', price: '40€', image: 'https://readdy.ai/api/search-image?query=Ciroc%20vodka%20bottle%20on%20simple%20dark%20gradient%20background%20with%20neon%20pink%20and%20cyan%20lighting%20effects%2C%20premium%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting&width=400&height=600&seq=ciroc1&orientation=portrait' },
                { name: 'Belvedere Vodka', price: '40€', image: 'https://readdy.ai/api/search-image?query=Belvedere%20vodka%20bottle%20on%20simple%20dark%20gradient%20background%20with%20neon%20pink%20and%20cyan%20lighting%20effects%2C%20premium%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting&width=400&height=600&seq=belvedere1&orientation=portrait' },
                { name: 'Jack Daniel\'s', price: '40€', image: 'https://readdy.ai/api/search-image?query=Jack%20Daniels%20whiskey%20bottle%20on%20simple%20dark%20gradient%20background%20with%20neon%20pink%20and%20cyan%20lighting%20effects%2C%20premium%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting&width=400&height=600&seq=jackdaniels1&orientation=portrait' }
              ].map((product, index) => (
                <div 
                  key={index}
                  className="group relative bg-black/60 backdrop-blur-sm rounded-3xl border-2 border-pink-400/50 overflow-hidden hover:border-pink-400 hover:scale-105 transition-all duration-300 cursor-pointer"
                  style={{ boxShadow: '0 0 20px rgba(255,0,110,0.3)' }}
                >
                  <div className="absolute top-4 left-4 z-10 px-3 py-1 bg-red-600 backdrop-blur-sm rounded-full text-white text-xs font-bold animate-pulse" style={{ textShadow: '0 0 10px rgba(255,0,0,0.8)' }}>
                    21+
                  </div>
                  <div className="w-full h-80 bg-gradient-to-b from-pink-900/30 to-black overflow-hidden">
                    <img 
                      src={product.image} 
                      alt={product.name}
                      className="w-full h-full object-contain object-top p-4 group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <h4 className="text-lg font-bold text-white mb-2">{product.name}</h4>
                    <p className="text-4xl font-black text-pink-400 mb-2" style={{ 
                      fontFamily: "'Orbitron', sans-serif",
                      textShadow: '0 0 15px rgba(255,0,110,0.8)'
                    }}>
                      {product.price}
                    </p>
                    <p className="text-xs text-red-400 font-semibold">Vente réservée aux majeurs</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Cigarettes Section */}
          <div className="mb-20">
            <h3 className="text-4xl font-bold text-orange-400 mb-8 flex items-center gap-3" style={{ 
              fontFamily: "'Orbitron', sans-serif",
              textShadow: '0 0 20px rgba(255,165,0,0.8)'
            }}>
              <i className="ri-fire-fill"></i>
              TABAC
            </h3>
            <div className="max-w-md">
              <div 
                className="group relative bg-black/60 backdrop-blur-sm rounded-3xl border-2 border-orange-400/50 overflow-hidden hover:border-orange-400 hover:scale-105 transition-all duration-300 cursor-pointer"
                style={{ boxShadow: '0 0 20px rgba(255,165,0,0.3)' }}
              >
                <div className="absolute top-4 left-4 z-10 px-3 py-1 bg-orange-600 backdrop-blur-sm rounded-full text-white text-xs font-bold" style={{ textShadow: '0 0 10px rgba(255,165,0,0.8)' }}>
                  TABAC 18+
                </div>
                <div className="flex items-center gap-6 p-6">
                  <div className="w-32 h-32 bg-gradient-to-b from-orange-900/30 to-black rounded-2xl overflow-hidden flex-shrink-0">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Phillip%20Morris%20cigarette%20pack%20on%20simple%20dark%20gradient%20background%20with%20neon%20orange%20and%20cyan%20lighting%20effects%2C%20product%20photography%20style%2C%20clean%20minimalist%20composition%2C%20Miami%20Vice%20aesthetic%2C%20professional%20studio%20lighting&width=300&height=300&seq=cigarettes1&orientation=squarish" 
                      alt="Phillip Morris"
                      className="w-full h-full object-contain object-center p-2 group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="flex-1">
                    <h4 className="text-xl font-bold text-white mb-2">Phillip Morris</h4>
                    <p className="text-4xl font-black text-orange-400 mb-2" style={{ 
                      fontFamily: "'Orbitron', sans-serif",
                      textShadow: '0 0 15px rgba(255,165,0,0.8)'
                    }}>
                      10€
                    </p>
                    <p className="text-xs text-orange-400 font-semibold">Vente réservée aux majeurs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-32 px-6 overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://readdy.ai/api/search-image?query=Neon%20lit%20night%20street%20scene%20in%20Creil%20France%20with%20turquoise%20and%20pink%20neon%20lights%2C%20Miami%20Vice%20aesthetic%2C%20retro%2080s%20vibe%2C%20VHS%20grain%20filter%20effect%2C%20cinematic%20night%20photography%2C%20urban%20nocturnal%20atmosphere%20with%20glowing%20storefronts&width=1920&height=800&seq=ctabg1&orientation=landscape" 
            alt="Night street"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-cyan-900/60 via-pink-900/40 to-purple-900/60"></div>
        </div>

        <div className="relative z-10 max-w-6xl mx-auto">
          <h2 className="text-7xl font-black text-white mb-16 lowercase" style={{ 
            fontFamily: "'Orbitron', sans-serif",
            textShadow: '0 0 30px rgba(0,255,240,0.9)'
          }}>
            REJOIGNEZ-NOUS
          </h2>

          <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
            <div>
              <a 
                href="https://www.tiktok.com/@mocroshit6.0?_r=1&_t=ZN-92z1A036EK" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-4 px-10 py-4 bg-pink-600 text-white text-lg font-bold rounded-full hover:bg-pink-500 transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ 
                  boxShadow: '0 0 30px rgba(255,0,110,0.8)',
                  fontFamily: "'Orbitron', sans-serif"
                }}
              >
                NOTRE TIKTOK
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-black text-pink-600">
                  <i className="ri-tiktok-fill text-xl"></i>
                </span>
              </a>
            </div>

            <div className="text-white text-right">
              <p className="text-xl mb-2 font-light">Suivez nos actus et promos</p>
              <p className="text-xl font-light">Contenus exclusifs chaque nuit</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 px-6 bg-gradient-to-b from-black via-cyan-950/10 to-black">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-5xl font-black mb-12 text-cyan-400" style={{ 
            fontFamily: "'Orbitron', sans-serif",
            textShadow: '0 0 30px rgba(0,255,240,0.8)'
          }}>
            NOUS TROUVER
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-black/60 backdrop-blur-sm rounded-3xl border-2 border-cyan-400/50 p-8" style={{ boxShadow: '0 0 20px rgba(0,255,240,0.3)' }}>
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-cyan-400/20 border-2 border-cyan-400">
                <i className="ri-map-pin-fill text-3xl text-cyan-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Adresse</h3>
              <p className="text-gray-300">2 rue Alphonse Daudet</p>
              <p className="text-gray-300">Creil, France</p>
            </div>

            <div className="bg-black/60 backdrop-blur-sm rounded-3xl border-2 border-pink-400/50 p-8" style={{ boxShadow: '0 0 20px rgba(255,0,110,0.3)' }}>
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-pink-400/20 border-2 border-pink-400">
                <i className="ri-time-fill text-3xl text-pink-400"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-3">Horaires</h3>
              <p className="text-gray-300">Tous les jours</p>
              <p className="text-2xl font-bold text-pink-400" style={{ textShadow: '0 0 15px rgba(255,0,110,0.6)' }}>20H - 6H</p>
            </div>
          </div>

          <div className="bg-black/60 backdrop-blur-sm rounded-3xl border-2 border-purple-400/50 p-8" style={{ boxShadow: '0 0 20px rgba(139,0,255,0.3)' }}>
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-purple-400/20 border-2 border-purple-400">
              <i className="ri-tiktok-fill text-3xl text-purple-400"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">Suivez-nous</h3>
            <a 
              href="https://www.tiktok.com/@mocroshit6.0?_r=1&_t=ZN-92z1A036EK" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-purple-400 hover:text-purple-300 transition-colors duration-300 text-lg underline cursor-pointer"
            >
              @mocroshit6.0
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="relative bg-black border-t border-cyan-400/30 py-16 px-6">
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, rgba(0,255,240,0.3) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }}></div>

        <div className="relative z-10 max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-12 mb-12">
            {/* Branding */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="https://static.readdy.ai/image/13311d918650e6bdc287990a476eb090/a902c8c3bd81fc0c31ca3a4e0028fe02.jpeg" 
                  alt="A'DAUDET SHOP" 
                  className="w-12 h-12 rounded-full object-cover border-2 border-cyan-400"
                />
                <h3 className="text-xl font-bold text-cyan-400" style={{ textShadow: '0 0 15px rgba(0,255,240,0.6)' }}>
                  A'DAUDET SHOP
                </h3>
              </div>
              <p className="text-gray-400 text-sm">Votre night shop Vice City à Creil</p>
            </div>

            {/* Menu */}
            <div>
              <h4 className="text-cyan-400 font-bold mb-4 text-lg">MENU</h4>
              <ul className="space-y-2">
                <li>
                  <button onClick={() => scrollToSection('boissons')} className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm cursor-pointer">
                    Boissons
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('confiseries')} className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm cursor-pointer">
                    Confiseries
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('alcools')} className="text-gray-400 hover:text-cyan-400 transition-colors duration-300 text-sm cursor-pointer">
                    Alcools
                  </button>
                </li>
              </ul>
            </div>

            {/* Infos */}
            <div>
              <h4 className="text-cyan-400 font-bold mb-4 text-lg">HORAIRES</h4>
              <p className="text-gray-400 text-sm mb-2">Tous les jours</p>
              <p className="text-white font-bold text-lg mb-4">20H - 6H</p>
              <p className="text-gray-400 text-sm">2 rue Alphonse Daudet</p>
              <p className="text-gray-400 text-sm">Creil, France</p>
            </div>

            {/* Social & Newsletter */}
            <div>
              <h4 className="text-cyan-400 font-bold mb-4 text-lg">RESTEZ CONNECTÉS</h4>
              <a 
                href="https://www.tiktok.com/@mocroshit6.0?_r=1&_t=ZN-92z1A036EK" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors duration-300 mb-6 cursor-pointer"
              >
                <i className="ri-tiktok-fill text-xl"></i>
                <span className="text-sm underline">@mocroshit6.0</span>
              </a>
              
              <button 
                onClick={() => setShowNewsletter(true)}
                className="w-full px-4 py-2 bg-cyan-400 text-black font-bold rounded-full hover:bg-cyan-300 transition-all duration-300 text-sm cursor-pointer whitespace-nowrap"
                style={{ boxShadow: '0 0 20px rgba(0,255,240,0.4)' }}
              >
                NEWSLETTER
              </button>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="border-t border-cyan-400/20 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="text-center md:text-left">
                <p className="text-3xl font-bold text-white mb-1" style={{ fontFamily: "'Orbitron', sans-serif" }}>
                  NIGHT VIBES
                </p>
                <p className="text-2xl font-bold text-cyan-400" style={{ fontFamily: "'Orbitron', sans-serif" }}>
                  MIAMI STYLE
                </p>
                <p className="text-xl font-bold text-pink-400" style={{ fontFamily: "'Orbitron', sans-serif" }}>
                  CREIL CITY
                </p>
              </div>

              <div className="text-center">
                <p className="text-gray-400 text-sm mb-2">© 2025 A'DAUDET SHOP</p>
                <p className="text-gray-500 text-xs">Tous droits réservés</p>
                <a 
                  href="https://readdy.ai/?ref=logo" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-cyan-400 hover:text-cyan-300 text-xs underline mt-2 inline-block cursor-pointer"
                >
                  Website Builder
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Newsletter Popup */}
      {showNewsletter && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm px-4">
          <div className="relative bg-gradient-to-br from-purple-900 to-black border-2 border-cyan-400 rounded-3xl p-8 max-w-md w-full" style={{ boxShadow: '0 0 40px rgba(0,255,240,0.6)' }}>
            <button 
              onClick={() => setShowNewsletter(false)}
              className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-cyan-400/20 text-cyan-400 hover:bg-cyan-400 hover:text-black transition-all duration-300 cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>

            <h3 className="text-3xl font-black text-cyan-400 mb-4" style={{ 
              fontFamily: "'Orbitron', sans-serif",
              textShadow: '0 0 20px rgba(0,255,240,0.8)'
            }}>
              NEWSLETTER
            </h3>
            <p className="text-gray-300 mb-6">Recevez nos offres nocturnes exclusives</p>

            <form 
              id="newsletter-form"
              data-readdy-form
              className="space-y-4"
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const data = new URLSearchParams();
                
                formData.forEach((value, key) => {
                  data.append(key, value.toString());
                });

                fetch('https://readdy.ai/api/form/d5hqbnbgekujqjrtspi0', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: data.toString()
                })
                .then(response => {
                  if (response.ok) {
                    alert('Merci pour votre inscription !');
                    form.reset();
                    setShowNewsletter(false);
                  } else {
                    alert('Une erreur est survenue. Veuillez réessayer.');
                  }
                })
                .catch(() => {
                  alert('Une erreur est survenue. Veuillez réessayer.');
                });
              }}
            >
              <input 
                type="email"
                name="email"
                placeholder="Votre email"
                required
                className="w-full px-4 py-3 bg-black/60 border-2 border-cyan-400/50 rounded-full text-white placeholder-gray-500 focus:outline-none focus:border-cyan-400 transition-all duration-300"
              />
              <button 
                type="submit"
                className="w-full px-6 py-3 bg-cyan-400 text-black font-bold rounded-full hover:bg-cyan-300 transition-all duration-300 cursor-pointer whitespace-nowrap"
                style={{ boxShadow: '0 0 20px rgba(0,255,240,0.6)' }}
              >
                S'INSCRIRE
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
